<template>
  <div>
    <SysBtn @click="dialog_ativo = !dialog_ativo">
      <v-icon size="18">mdi-chart-bell-curve</v-icon>
      <span class="ml-1">Definir cobertura por curvas</span>
    </SysBtn>

    <v-dialog v-model="dialog_ativo" width="600" content-class="bra-20" transition="dialog-top-transition">
      <v-card class="px-3 overflow-hidden">
        <v-card-title class="py-4 pr-2 pl-1">
          <span class="font-18">Coberturas por curvas</span>
          <v-spacer />
          <button class="sys-btn text-subtitle-2 px-2" @click="() => { dialog_ativo = false; dialog_informacao = true; }">
            Saiba como configurar
          </button>
          <v-btn class="ml-2" icon small @click="dialog_ativo = !dialog_ativo">
            <v-icon size="22">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0 pl-1">
          <div class="d-flex align-center">
            <IndicadorImportancia style="rotate: -90deg;position: absolute;margin-left: -201px;margin-top: 8%;" />

            <div class="w-full ml-18px">
              <table id="tabela-curvas-coberturas">
                <tr class="text-left font-13 font-weight-medium text-white" style="background: #d0c4c4">
                  <td class="pl-3">Frequência</td>
                  <td>Faturamento</td>
                  <td>Cobertura</td>
                </tr>

                <tr
                  v-for="(item, index) in coberturas" :key="index"
                  :class="[
                    `background-importancia-${index}`,
                    (index > 0 && Number.isInteger(index / 3)) ? 'dividir-curvas' : undefined
                  ]"
                  class="font-13"
                >
                  <td v-text="item.classificacao_popularidade" class="pl-3" />
                  <td v-text="item.classificacao_criticidade" />
                  <td class="w-80">
                    <div class="d-flex align-center justify-center pb-2 pr-2">
                      <TextFieldFormatadorDeValor
                        v-model="item.tempo_cobertura"
                        dense
                        class="text-field-centralizado"
                        hide-details
                        style="font-size: 13px"
                        @focus="$event.target.select()"
                        @keydown.enter="salvarCoberturas"
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </v-card-text>

        <div class="d-flex align-center py-5">
          <v-spacer />
          <v-btn small color="#0d4663" dark @click="salvarCoberturas">salvar</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <SysDialog
      @click:primary="() => { dialog_informacao = false; dialog_ativo = true; }"
      @click:hidden-dialog="() => { dialog_informacao = false; dialog_ativo = true; }"
      v-model="dialog_informacao"
      titulo="Cobertura de Estoque Inversamente Proporcional"
      txt-botao="Fechar"
      :largura="800"
      :ocultarAcoes="true"
    >
      <div class="sys-dialog">
      <span class="text-h6 font-weight-bold">O que é?</span>
      <p>
        A estratégia de cobertura inversamente proporcional ajusta os dias de estoque de cada produto de forma inversa à sua importância e rotatividade:
      </p>
      <ul>
        <li>Itens-chave (alto faturamento/alta frequência) recebem menos dias, para compras mais frequentes.</li>
        <li>Itens de menor impacto recebem mais dias, para compras menos frequentes.</li>
      </ul>
      <span class="text-h6 font-weight-bold">Por que usar?</span>
      <p>
        <b>Foco no que gera resultado</b><br>
        Pelo Princípio de Pareto, 20 % dos seus itens respondem por cerca de 80 % do faturamento. Ao reduzir a cobertura (dias de estoque) desses itens “A”, você compra com mais frequência, evita ruptura e mantém alta disponibilidade.
      </p>
      <p>
        <b>Liberação de capital</b><br>
        Menos dias de estoque nos itens caros e de alta rotação libera caixa para investir em um mix mais amplo de produtos, sem aumentar o montante total aplicado em estoque.
      </p>
      <p>
        <b>Acelera o giro e a liquidez</b><br>
        Produtos “A” giram mais rápido quando comprados em lotes menores e repetidos. O capital retorna em menor intervalo, melhorando sua liquidez operacional.
      </p>
      <p>
        <b>Potencialização de itens “C”</b><br>
        Ao aumentar a cobertura dos produtos de menor impacto, você reduz o esforço de comprá-los e ganha margem para promover esses itens, ajudando a elevar sua performance ao longo do tempo.
      </p>
      <br>
      <p class="d-flex justify-center">
        <SysBtn @click="() => { dialog_informacao = false; dialog_ativo = true; }">
          Fechar
        </SysBtn>
      </p>
      </div>
    </SysDialog>
  </div>
</template>

<script>
import {atualizarParametrizacaoCoberturasPorCurvas, buscarParametrizacaoCoberturasPorCurvas} from "@/api/Diagnostico/CurvasCruzadas";
import {arrayColumn, logout} from "@/helpers";
import {coberturas_padrao} from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/CoberturasCurvasPadrao";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor";
import IndicadorImportancia from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/IndicadorImportancia";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

export default {
  name: "DefinicaoDeCoberturas",
  components: {
    IndicadorImportancia,
    TextFieldFormatadorDeValor,
    SysDialog
  },
  data: () => ({
    dialog_ativo: null,
    dialog_informacao: false,
    coberturas: coberturas_padrao
  }),
  computed: {
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    }
  },
  watch: {
    dialog_ativo(_, valor_anterior) {
      if (valor_anterior === null) {
        this.buscarParametrizacaoAtual();
      }
    }
  },
  methods: {
    buscarParametrizacaoAtual() {
      const parametros = {
        id_grupo: this.GRUPO_COMPRA
      }
      this.$store.dispatch('loading/addRequisicao',
        buscarParametrizacaoCoberturasPorCurvas(parametros)
          .then(coberturas => {
            if (coberturas.length > 0) {
              this.coberturas = coberturas;
            } else {
              this.coberturas = coberturas_padrao;
            }
          })
          .catch(logout)
      );
    },
    salvarCoberturas() {
      const parametros = {
        id_grupo: this.GRUPO_COMPRA,
        coberturas: arrayColumn(this.coberturas, ['pqr', 'xyz', 'tempo_cobertura'])
      };
      this.$store.dispatch('loading/addRequisicao',
        atualizarParametrizacaoCoberturasPorCurvas(parametros)
          .then(() => {
            this.dialog_ativo = false;
            this.$emit('coberturas-alteradas', {});
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
#tabela-curvas-coberturas {
  width: 100%;
  border-collapse: collapse;
}
.dividir-curvas td {
  border-top: 2px solid white;
}
#tabela-curvas-coberturas tr td {
  color: #171616;
}
.ml-18px {
  margin-left: 18px;
}
.background-importancia-0 {
  background: #e1d0d0;
}
.background-importancia-1 {
  background: #e0d4d4;
}
.background-importancia-2 {
  background: #e5dada;
}
.background-importancia-3 {
  background: #ece3e3;
}
.background-importancia-4 {
  background: #efe8e8;
}
.background-importancia-5 {
  background: #f3efef;
}
.background-importancia-6 {
  background: #f5f1f1;
}
.background-importancia-7 {
  background: #faf7f7;
}
.background-importancia-8 {
  background: #fffbfb;
}

.sys-btn {
  background-color: #f5f4f4;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 16px;
  border: 1px solid #e5e5e5;
  color: #2c2c2c;
}
.sys-btn:hover {
  box-shadow: 0 0 2px #c7c6c6;
  transition: .2s;
}

.sys-dialog {
  color: #171212;
}
</style>
